/* 🤖 this file was generated by svg-to-ts*/
export const icoWindows: {
  name: 'windows';
  data: string;
} = {
  name: 'windows',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.412 12.632L21 12.79V22l-10.588-2.01v-7.358zM3 12.526l6.353.095v7.168L3 18.58v-6.053zm6.353-7.968v6.82L3 11.475V5.947l6.353-1.39zM21 2v9.21l-10.588.158V4.326L21 2z" fill="#909090"/></svg>`
};
